<div>
  <div class="mt-block">
    <div class="mt-wrapper">
      <section class="mt-section">
        <fou-container :id="$vId(this, 'applications-ui')" cols="12">
          <template #header>
            <h3 class="mt-h3">{{$t('pages.foundry_support_applications.dashboard.title')}}</h3>
          </template>
          <template #content>
            <div>
              <v-grid :class="$style.filter">
                <v-row>
                  <v-col :has="{'default': 4, 's': 10}" off="1">
                    <ul class="out-left mt-list mt-list--horizontal">
                      <li class="mt-list-item" v-for="item in status">
                        <button
                          type="button"
                          :class="filterClass(item.query)"
                          @click="getApplicationsByStatus(item.query)"
                        >
                          {{$t(`pages.foundry_support_applications.dashboard.status.${item.name}`)}}
                          <fou-span :listCount="count[item.countLabel]"></fou-span>
                        </button>
                      </li>
                    </ul>
                  </v-col>
                  <v-col :has="{'default': 6, 's': 10}" :off="{'default': 0, 's': 1}">
                    <div class="out-right mt-flex mt-flex--end" :class="$style.searchBox">
                      <button v-if="!searchStateValue" class="mt-icon mt-icon-zoom" :class="$style.searchIcon"></button>
                      <button
                        v-if="searchStateValue"
                        type="button"
                        class="mt-icon mt-icon-close"
                        :class="$style.searchClear"
                        @click="searchClear"
                      ></button>
                      <input
                        class="mt-input"
                        :class="$style.searchInput"
                        type="search"
                        v-model="searchKeyword"
                        :placeholder="$t('pages.home.components.support_submissions.search.placeholder')"
                        @change="search()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-grid>

              <v-grid element="ul" class="mt-list" :class="$style.listHeader">
                <v-row element="li" :class="[$style.customList, $style.textCenter]" class="mt-list-item">
                  <v-col has="2">
                    <button
                      type="button"
                      :class="sortStyle('applicationStatus')"
                      @click="sortApplications('applicationStatus')"
                      class="mt-label mt-label--capitalise mt-label--greylabel"
                    >
                      {{$t('pages.foundry_support_applications.dashboard.categories.status')}}
                    </button>
                  </v-col>

                  <v-col has="2" :class="$style.textLeft">
                    <span :class="$style.foundryNm">
                      <button
                        type="button"
                        :class="sortStyle('foundryName')"
                        @click="sortApplications('foundryName')"
                        class="mt-label mt-label--capitalise mt-label--greylabel"
                      >
                        {{$t('pages.foundry_support_applications.dashboard.categories.foundry_name')}}
                      </button>
                    </span>
                  </v-col>

                  <v-col has="2" :class="$style.textLeft">
                    <span :class="$style.userNm">
                      <button
                        type="button"
                        :class="sortStyle('userName')"
                        @click="sortApplications('userName')"
                        class="mt-label mt-label--capitalise mt-label--greylabel"
                      >
                        {{$t('pages.foundry_support_applications.dashboard.categories.user_name')}}
                      </button>
                    </span>
                  </v-col>

                  <v-col has="2">
                    <span :class="$style.submittedDt">
                      <button
                        type="button"
                        :class="sortStyle('createdAt')"
                        @click="sortApplications('createdAt')"
                        class="mt-label mt-label--capitalise mt-label--greylabel"
                      >
                        {{$t('pages.foundry_support_applications.dashboard.categories.submitted_date')}}
                      </button>
                    </span>
                  </v-col>
                  <v-col has="2">
                    <span :class="$style.submittedDt">
                      <button
                        type="button"
                        :class="sortStyle('updatedAt')"
                        @click="sortApplications('updatedAt')"
                        class="mt-label mt-label--capitalise mt-label--greylabel"
                      >
                        {{$t('pages.foundry_support_applications.dashboard.categories.updated_date')}}
                      </button>
                    </span>
                  </v-col>
                  <v-col has="2">
                    <span :class="$style.submittedDt">
                      <button
                        type="button"
                        :class="sortStyle('predictionScore')"
                        @click="sortApplications('predictionScore')"
                        class="mt-label mt-label--capitalise mt-label--greylabel"
                      >
                        {{$t('pages.foundry_support_applications.dashboard.categories.prediction_score')}}
                      </button>
                    </span>
                  </v-col>
                </v-row>
              </v-grid>

              <div :class="$style.submissions">
                <div :id="$vId(this, 'applications-list')" :class="$style.submissionsInside">
                  <v-grid element="ul" class="mt-list">
                    <a
                      v-for="application, key in applications"
                      :key="key"
                      class="row mt-list-item"
                      :href="`/application-preview/${application.id}`"
                      :class="[$style.listItem, $style.listItemHover, $style.textCenter]"
                    >
                      <v-col has="2">
                        <div :class="$style.capitalise" class="mt-serif mt-serif--size6">
                          {{replaceString(application.applicationStatus, '_', ' ')}}
                        </div>
                      </v-col>

                      <v-col has="2" :class="$style.textLeft">
                        <div
                          :class="[$style.capitalise, $style.wordWrap]"
                          class="mt-serif mt-serif--size6 mt-serif--bold"
                        >
                          {{application.foundryName}}
                        </div>
                      </v-col>

                      <v-col has="2" :class="$style.textLeft">
                        <span :class="$style.userNm">
                          <div :class="$style.capitalise" class="mt-serif mt-serif--size6">
                            {{application.userName}}
                          </div>
                        </span>
                      </v-col>

                      <v-col has="2">
                        <span :class="$style.submittedDt">
                          <div class="mt-serif mt-serif--size6 mt-serif--bold">
                            {{UTCFormatDate(application.createdAt, $lang, 'L')}}
                          </div>
                        </span>
                      </v-col>
                      <v-col has="2">
                        <span :class="$style.submittedDt">
                          <div class="mt-serif mt-serif--size6 mt-serif--bold">
                            {{UTCFormatDate(application.updatedAt, $lang, 'L')}}
                          </div>
                        </span>
                      </v-col>
                      <v-col has="2" :class="$style.textRight">
                        <span :class="$style.userNm">
                          <div class="mt-serif mt-serif--size6" :class="[application.predictionScore === 'NA' ? $style.notPresent : (
                            application.predictionScore > 0.5.toFixed(3) ? $style.goodPrdScore : (
                              application.predictionScore <= 0.5.toFixed(3) &&  application.predictionScore > 0.2.toFixed(3) ? $style.avgPrdScore : (
                                application.predictionScore <= 0.2.toFixed(3) ? $style.lowPrdScore : ''
                              ))
                          )]">
                            {{ application.predictionScore }}
                          </div>
                        </span>
                      </v-col>
                    </a>
                    <a v-if="loadActive" class="row mt-list-item" :class="$style.listItem">
                      <div :class="$style.spinner">
                        <animation-processing fill="new-blue" />
                      </div>
                    </a>
                  </v-grid>
                </div>
                <transition name="fade">
                  <div v-if="!scrollEnd && applications.length > 0" :class="$style.listFadeOut"></div>
                </transition>
              </div>
            </div>
          </template>
        </fou-container>
      </section>
    </div>
  </div>
</div>
